import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import HomestayRoomTypeDetail from './HomestayRoomTypeDetail';
import action from '../../../../../actions/index';
import * as homestayRoomTypeAction from '../../../../../actions/homestayRoomTypeAction.js';
import * as amenityActions from './../../../../../actions/amenityAction';

const mapStateToProps = state => {
    return {
        homestayRoomTypeState: state.homestayRoomTypeReducer,
        uploadState: state.uploadReducer,
        amenityState: state.amenityReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        getHomestayRoomType: (id) => {
            dispatch(action.getHomestayRoomType(id))
        },
        saveHomestayRoomType: (id) => {
            dispatch(action.saveHomestayRoomType(id))
        },
        createHomestayRoomTypeTranslate: (homestayRoomType, language) => dispatch(homestayRoomTypeAction.createHomestayRoomTypeTranslate(homestayRoomType, language)),
        updateHomestayRoomTypeTranslate: (homestayRoomType, language) => dispatch(homestayRoomTypeAction.updateHomestayRoomTypeTranslate(homestayRoomType, language)),
        deleteHomestayRoomTypeTranslate: (homestayRoomType, refreshParams) => dispatch(homestayRoomTypeAction.deleteHomestayRoomTypeTranslate(homestayRoomType, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HomestayRoomTypeDetail));
